<template>
	<div class="modal-column">
		<div class="modal-column-body">
			<Form mode="block" ref="form" :rules="{}" :model="formData">
				<div class="inline-form-item">
					<FormItem label="编码" prop="code" required>
						<NumberInput v-model="formData.code"/>
					</FormItem>
					<FormItem label="名称" prop="name" required>
						<Input type="text" v-model="formData.name"/>
					</FormItem>
					<FormItem label="客户类别" prop="category">
						<Input type="text" v-model="formData.category"/>
					</FormItem>
				</div>
				<div class="inline-form-item">
					<FormItem label="联系人" prop="contact">
						<Input type="text" v-model="formData.contact"/>
					</FormItem>
					<FormItem label="手机" prop="telPhone">
						<Input type="text" v-model="formData.telPhone"/>
					</FormItem>
				</div>
				<div class="inline-form-item">
					<FormItem label="统一社会信用代码" prop="creditCode">
						<Input type="text" v-model="formData.creditCode"/>
					</FormItem>
					<FormItem label="经营地址" prop="address">
						<Input type="text" v-model="formData.address"/>
					</FormItem>
				</div>
				<FormItem label="备注" prop="remark">
					<Input type="text" v-model="formData.remark"/>
				</FormItem>
			</Form>
		</div>
		<div class="modal-column-btn modal-column-between">
			<vxe-button :loading="loading" icon="fa fa-close" @click="$emit('close')">取消</vxe-button>
			<vxe-button :loading="loading" status="primary" icon="fa fa-save" @click="onSave">保存</vxe-button>
		</div>
	</div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
	name: "CustomerForm"
}
</script>


<script setup>
import {reactive, ref, defineEmits, defineProps, toRefs} from "vue";
import {Customer} from "@/api/Auxiliary";
import {message} from "heyui.ext";
import {CopyObj} from "@/js/common/utils";

const emit = defineEmits(['close', 'success'])
const props = defineProps(['entity', 'category'])

const {entity} = toRefs(props)
const loading = ref(false);
const form = ref(null);

const formData = reactive({
	id: null,
	code: null,
	enable: true,
	name: null,
	remark: null,
	address: null,
	categoryId: props.category.id,
	category: null,
	contact: null,
	creditCode: null,
	telPhone: null,
})

const onSave = () => {
	const validResult = form.value.valid();
	if (validResult.result) {
		loading.value = true;
		formData.categoryId = props.category.id
		Customer.save(formData).then(() => {
			message("保存成功~")
			emit('success')
		}).finally(() => loading.value = false)
	}
}
CopyObj(formData, entity.value);
</script>
